export enum AppointmentAvailabilityEnum {
  NO_APPOINTMENTS = 'No Appointments',
  NO_FUTURE_APPOINTMENTS = 'No Future Appointments',
  APPOINTMENTS_AVAILABLE = 'Appointments Available'
}

